import gql from 'graphql-tag';

export class FormInput {
  id: number;
  collectorId: number;
  materialId: number;
  contractNo: string;
  contractSignDate: string;
  contractExpDate: string;
  isActive: boolean;

  constructor() {
    this.id = undefined;
    this.collectorId = undefined;
    this.materialId = undefined;
    this.contractNo = undefined;
    this.contractSignDate = undefined;
    this.contractExpDate = undefined;
    this.isActive = undefined;
  }
}

export const gqlGetWCPMaterialsQuery = gql`
  query getWastereceptionpointsMaterials(
    $limit: Int
    $offset: Int
    $order: String
    $where: String
  ) {
    getWastereceptionpointsMaterials(limit: $limit, offset: $offset, order: $order, where: $where) {
      data {
        id
        wastereceptionpointId
        materialId
        material {
          id
          name
          notes
        }
        activityCode
        isActive
        firstDate
        lastDate
        firstUser
        lastUser
      }
      recordCount
    }
  }
`;

export const gqlΙnitializeWCPMaterials = gql`
  mutation initializeWastereceptionpointsMaterials {
    initializeWastereceptionpointsMaterials
  }
`;

export const gqlUpdateWCPMaterial = gql`
  mutation updateWastereceptionpointsMaterial($data: WastereceptionpointsMaterialInput) {
    updateWastereceptionpointsMaterial(data: $data) {
      id
    }
  }
`;
